import {initYandexMap} from "./initYandexMap";
import {API_MAP_KEY} from "./constants";

export const initDivMap = () => {
	const script = document.createElement(`script`);
	script.src = API_MAP_KEY;
	document.body.appendChild(script);
	script.addEventListener(`load`, initYandexMap);
};
